import Users from "@/pages/Users/index.vue";
import UserDicsTabs from "@/pages/UserDics/tabs.vue";
import UserDicsList from "@/pages/UserDics/list.vue";
import Roles from "@/pages/Roles/index.vue";
import HistoryActions from "@/pages/HistoryActions/index.vue";
import auth from "../middleware/authMiddleware.js";
import canNav from "../middleware/canNavMiddleware.js";

export default [
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "Users/view"
    }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "Roles/view"
    }
  },
  {
    path: "/user-dics",
    name: "UserDics",
    component: UserDicsTabs,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "UserDics/view"
    },
    // Вкладки (словари)
    children: [
      {
        path: ":dicId",
        name: "UserDicsList",
        component: UserDicsList,
        props: true,
        meta: {
          middleware: [auth],
          requirePermission: "UserDics/view",
          parentName: "UserDics",
          hiddenInToolbar: true
        }
      }
    ]
  },
  {
    path: "/history-actions",
    name: "HistoryActions",
    component: HistoryActions,
    meta: {
      middleware: [auth, canNav],
      requirePermission: "HistoryActions/view"
    }
  }
];
